import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dataBar-1",
  "use": "icon-dataBar-1-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dataBar-1\">\n<g id=\"icon-dataBar-1_icon\">\n<g id=\"icon-dataBar-1_Group 178171\">\n<rect id=\"icon-dataBar-1_Rectangle 8062\" x=\"7.15063\" y=\"8\" width=\"20.6676\" height=\"15.031\" rx=\"1\" fill=\"#A1B4CC\" />\n<path id=\"icon-dataBar-1_Vector 1095\" d=\"M27.8181 15.5146H37.2125V34.3034H13.7266\" stroke=\"#A1B4CC\" />\n<rect id=\"icon-dataBar-1_Rectangle 8063\" x=\"7.15063\" y=\"29.6064\" width=\"12.2127\" height=\"9.39438\" rx=\"1\" fill=\"#A1B4CC\" />\n<rect id=\"icon-dataBar-1_Rectangle 8064\" x=\"30.6365\" y=\"29.6064\" width=\"12.2127\" height=\"9.39438\" rx=\"1\" fill=\"#A1B4CC\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dataBar-1.svg
// module id = J286
// module chunks = 102